import { ConfirmationDialog } from "ui/confirmation-dialog";

interface ConfirmUpdateMergeTagsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
}

const HEADLINE = "Update merge tags for this version?";
const MESSAGE = "This creates a new draft with merge tags updated.";
const CONFIRM_BUTTON_TEXT = "Update";
const CONFIRM_LOADING_MESSAGE = "Updating...";

const ConfirmUpdateMergeTagsModal = ({
  isOpen,
  onClose,
  onSubmit,
}: ConfirmUpdateMergeTagsModalProps) => (
  <ConfirmationDialog
    open={isOpen}
    onClose={onClose}
    headline={HEADLINE}
    message={MESSAGE}
    confirmButtonText={CONFIRM_BUTTON_TEXT}
    confirmLoadingMessage={CONFIRM_LOADING_MESSAGE}
    onConfirm={onSubmit}
  />
);

export default ConfirmUpdateMergeTagsModal;
